// DATE FORMATS
export const DATE_FORMAT = 'M/D/YYYY';
export const READABLE_SHORT_DATE = 'MMM D';
export const READABLE_SHORT_DATE_WITH_YEAR = 'MMM D, YYYY';
export const READABLE_SHORT_DATE_WITH_DAY_OF_WEEK = 'dddd (MMM D)';

// MEAL TYPES
export const MEAL_PLAN_MEAL_TYPES = ['Breakfast', 'Lunch', 'Dinner', 'Snack', 'Dessert'];